import type { MenuItem } from '@/consts/navigation';
import { cn } from '@/utils/cn';
import { useTranslation } from 'react-i18next';

import { useNavigationContext } from '../context/NavigationContext';
import { NavMenuItemsList } from './NavMenuItemsList';

interface NavMenuItemGroupProps {
  item: MenuItem;
  isPopover: boolean;
  isUtilitySection: boolean;
  isFirst: boolean;
}

export const NavMenuItemGroup = ({ item, isPopover, isUtilitySection, isFirst }: NavMenuItemGroupProps) => {
  const { t } = useTranslation();
  const { isNavCollapsed } = useNavigationContext();

  if (isNavCollapsed && !isPopover) {
    return (
      <li role="none">
        {!isFirst && <div className="border-border-500/40 mx-2 my-2 border-t" />}
        {item.children && item.children.length > 0 && (
          <NavMenuItemsList items={item.children} variant="expanded" isUtilitySection={isUtilitySection} nested />
        )}
      </li>
    );
  }

  return (
    <li role="none">
      <div className={cn('mb-1.5 flex items-center gap-2 px-3', !isFirst && 'mt-3')}>
        <span className="text-nav-group text-[10px] font-semibold whitespace-nowrap uppercase">{t(item.text)}</span>
        <div className="bg-border-500/40 h-px flex-1" />
      </div>
      {item.children && item.children.length > 0 && (
        <NavMenuItemsList
          items={item.children}
          variant={isPopover ? 'popover' : 'expanded'}
          isUtilitySection={isUtilitySection}
          nested
        />
      )}
    </li>
  );
};
